import { jsx as _jsx } from "react/jsx-runtime";
import { MessageCircleQuestion, MessageSquareMore } from 'lucide-react';
import { cn } from '../../lib/utils';
/**
 * Leading icon that tells a form item's delivery apart at a glance:
 * Instruction items (the agent words it in character) get a chat bubble,
 * questions said as written get a question bubble, and statements said as
 * written get an empty slot so the text column stays aligned.
 */
export function FormItemIcon({ item, className, }) {
    const slot = cn('h-3 w-3 flex-shrink-0 text-muted-foreground', className);
    if (item.mode === 'instruction') {
        return (_jsx("span", { title: "Instruction: the agent words this in its own voice", children: _jsx(MessageSquareMore, { className: slot, "aria-label": "Instruction" }) }));
    }
    if (item.kind === 'question') {
        return (_jsx("span", { title: "Question: the agent asks this as written", children: _jsx(MessageCircleQuestion, { className: slot, "aria-label": "Question" }) }));
    }
    return _jsx("span", { className: slot, "aria-hidden": true });
}
//# sourceMappingURL=FormItemIcon.js.map